import React, {useState, useEffect} from 'react';
import {
  Progress,SearchOutlined , Table, useDispatch, useSelector, Input,Space
} from '../AntComponent';
import {getRecentDocumentData} from '../../store/actions/DocumentManagerAction'

export default function InnerDocManager (props){
  const dispatch = useDispatch()
  const [searchTableVal, setsearchTableval] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { profileInfo } = useSelector(state => state.userPrf);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const {recDoc,loading,success } = useSelector(state => state.documentManager);
  const [showSuccessMsg2, setShowSuccessMsg2] = useState(false);
  const successmsg2 = showSuccessMsg2 ? success : null;
  const [recentFileList, setRecentFileList]= useState([])
  const totalPage = recDoc?.data?.serverSearchables?.recordsTotal || 0;
  const documentType = props.data.documentType;
  const backBtnClick =()=>{
    props.data.callbackFunction(true);
  }

  function getRecentDoc( pageIndex, pageSize, sortOrder,searchTableVal){
    let inputJson ={
      "objDocuInput": {
          "ProductID": productID,
          "TenantID": tenantID
      },
      "ServerSearchables": {
        "SearchData": searchTableVal,
        "PageNumber": pageIndex,
        "PageSize": pageSize,
        "OrderByColumn": "",
        "OrderBy": sortOrder
      },
      "objDocuList": []
    }
    dispatch(getRecentDocumentData(inputJson)) 
    setShowSuccessMsg2(true)
  }
  const getRecentFileSize = ()=>{
    const units = ['byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const tempRecentFileList = [];

    for (let i = 0; i < recDoc?.data?.objDocuList.length; i++) {
      let val = '';
      let l = 0;
      let n = parseInt(recDoc?.data?.objDocuList?.[i]?.docSize, 10) || 0;

      while (n >= 1024 && ++l) {
        n = n / 1024;
      }

      val = n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];

      tempRecentFileList.push({
        ...recDoc?.data?.objDocuList[i],
        fileSize: val,
      });
    }
    setRecentFileList(tempRecentFileList);
  }
  useEffect(()=>{
    getRecentFileSize();
  },[recDoc])

  const tableChange = (pagination, ...sorted) => {
    let sort = "";
    if (sorted[1].order == "ascend") {
      sort = "asc";
    } else sort = "desc";
    setSortField(sorted[1].field);
    setSortOrder(sort);
    setPageIndex(pagination.current);
    getRecentDoc( pagination.current, pagination.pageSize, "",searchTableVal);
  }

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setsearchTableval(e.target.value);
      setPageIndex(1);
      getRecentDoc( 1, pageSize, null,e.target.value);
    }
  }

  const resetSearch = (e) => {
    if (e.key === "Backspace" && !e.target.value) {
      setsearchTableval("");
      setPageIndex(1);
      getRecentDoc(1, pageSize, null,e.target.value);
    }
  }

  useEffect(() => {
    if (successmsg2) {
      setRecentFileList(recDoc?.data?.objDocuList)
      setShowSuccessMsg2(false)
    }
  }, [successmsg2]); 

  useEffect(()=>{
    getRecentDoc(pageIndex, pageSize, sortOrder,searchTableVal);
  },[tenantID])

  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'documentName',
      key: 'documentName',
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Size',
      dataIndex: 'fileSize',
      key: 'fileSize',
      width: 150,
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Document Type',
      dataIndex: 'docType',
      key: 'docType',
      render: (text) => <span className="text-start">{text}</span>,
    },
    {
      title: 'Last Modified',
      dataIndex: 'createdOn',
      key: 'createdOn',
      width: 250,
      render: (text) => (
        <span className="text-start">
          {new Date(text).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          })}
        </span>
      ),
    },
  ];

  return (
    <div className='docManager'>
    {
      !props.data.showDocument && (
        <div className='w-100 docType bg-white p-3'>
          <div className="d-flex justify-content-between px-3 mb-4">
            <div>
              <h6>Document Types</h6>
            </div>
            <div>
              <button className="rounded text-white bg-danger border-0 px-3 p-1" onClick={backBtnClick}>
                Back
              </button>
            </div>
          </div>
          <div className="documentTypeCard row">
            {documentType?.map((item, index) => (
              <React.Fragment key={item.docType}>
                <div className="contentCard  col-md-4 mb-4 p-4 px-3 ms-4  rounded">
                  <div className="mt-3">
                    <span className="folderIcon">📁</span>
                    <span className="ps-1 innerCardContent">{item.docType}</span>
                  </div>
                  <div className="mt-3 text-center">
                    <Progress percent={item.usedStorage} status="active" />
                  </div>
                </div>
                {(index + 1) % 3 === 0 && <div key={`line-break-${index}`} className="w-100"></div>}
              </React.Fragment>
            ))}
          </div>
        </div>
      )
    }
    <div>
      {props.data.showDocument && (
        <div className="documentTableParent security pt-5 bg-white p-3 ">
          <div className="d-flex justify-content-between px-3">
            <div>
              <h6>Document Types</h6>
            </div>
            <div className="d-flex">
              <Space compact="true" className="form-control serverSearch rounded me-3 d-flex">
                <Input
                  placeholder="Search Document"
                  className="search_bar p-0 ps-2"
                  value={searchTableVal}
                  onKeyDown={(e) => handleSearch(e)}
                  onKeyUp={(e) => resetSearch(e)} 
                  onChange={(e) => setsearchTableval(e.target.value)}
                />
                <span className="extInputIcon">
                  <SearchOutlined onClick={handleSearch} />
                </span>
              </Space>
              <button
                className="rounded text-white bg-danger border-0 px-3 p-1"
                onClick={backBtnClick}
              >
                Back
              </button>
            </div>
          </div>

          <div>
            <Table rowKey="docID"
              className="allRecentFile p-3 pb-0 border-0"
              dataSource={recentFileList}
              columns={columns}
              pagination={{
                total:totalPage,
                current: pageIndex,
                pageSize,
                showSizeChanger: true,
                onChange: (page, pageSize) => {
                  setPageIndex(page);
                  setPageSize(pageSize);
                  getRecentDoc(page, pageSize, sortOrder,searchTableVal);
                }
              }}
              onChange={tableChange}
              loading={loading}
            />
          </div>
        </div>
      )}
  </div>
</div>
  )
}